import type { StanDataColumn } from '@/components/core-components/StanDataRow/StanDataRow.types';

/**
 * Grid column configuration for automations
 * Defines column widths as percentages (2fr = 40%, 1fr = 20% each)
 */
export const AUTOMATION_GRID_COLUMNS = {
    keywords: 40,
    sent: 20,
    clicks: 20,
    optIns: 20,
} as const;

/**
 * Header column definitions for AutomationsList
 */
export const AUTOMATION_HEADER_COLUMNS: StanDataColumn[] = [
    {
        id: 'keywords',
        name: 'Keywords',
        width: AUTOMATION_GRID_COLUMNS.keywords,
    },
    {
        id: 'sent',
        name: 'Sent',
        width: AUTOMATION_GRID_COLUMNS.sent,
    },
    {
        id: 'clicks',
        name: 'Clicks',
        width: AUTOMATION_GRID_COLUMNS.clicks,
    },
    {
        id: 'opt-ins',
        name: 'Opt-Ins',
        width: AUTOMATION_GRID_COLUMNS.optIns,
    },
];
